<template>
  <div id="account">
    <!-- 登录盒子 -->
    <div class="login-box">
      <!-- 手机号输入 -->
      <el-input v-model="account"
                placeholder="请输入账号"
                class="input-item phone-input">
        <!-- 图标插槽 (模拟手机图标) -->
        <!--   <i slot="prefix"
           class="el-input__icon el-icon-mobile-phone"></i> -->
      </el-input>

      <div class="codeFn">
        <!-- 验证码输入 -->
        <el-input v-model="password"
                  placeholder="请输入密码"
                  class="input-item code-input">
          <!--   <i slot="prefix"
             class="el-input__icon el-icon-message"></i> -->
        </el-input>
      </div>

      <!-- 登录按钮 -->
      <el-button type="primary"
                 class="login-btn"
                 @click="handleLogin">
        登录
      </el-button>

      <!-- 自动登录 -->
      <div class="auto-login">
        <el-checkbox v-model="autoLogin">自动登录</el-checkbox>
        <div>忘记密码？</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as req from "@/utils/request";
export default {
  name: 'HgOnlineIphoneLogin',

  data() {
    return {
      account: '',
      password: '',
      autoLogin: false
    }
  },

  mounted() {},

  methods: {
    handleLogin() {
      let obj = {
        nickname: this.account,
        password: this.password
      }
      let sendData = {}
      sendData.data = obj
      sendData.fn = this._loginFn
      sendData.vm = this
      req.Post('account/doLogin', sendData)
    },
    _loginFn(res) {
      if (res.code === 200) {
        this.$message.success('登录成功')
        this.$router.push({ name: '/' })
        window.location.reload()
        window.localStorage.setItem("Authorization", res.data)
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style scoped>
#account {
  width: 100%;
  height: 100%;
}
/* 登录盒子 */
.login-box {
  width: 70%;
  height: 3rem;
  padding: 0.1rem;
  border-radius: 0.1rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

/* 输入框统一样式 */
.input-item {
  border-radius: 0.1rem;
}
.phone-input /deep/ .el-input__inner {
  background-color: #f4f4f4;
  border: 1px solid #d8d8d8;
  height: 0.5rem;
  line-height: 0.5rem;
}
.code-input /deep/ .el-input__inner {
  height: 0.5rem;
  line-height: 0.5rem;
  background-color: #f4f4f4;
}
/* 按钮样式覆盖 */
/deep/ .el-input-group__append {
  border-left: none !important;
  background-color: white;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #023e7c !important;
  border-color: #023e7c !important;
  margin-right: 0.1rem;
}

/deep/ .el-checkbox__inner {
  margin-right: 0.1rem;
}

/deep/ .el-button--primary {
  border: none;
}

/deep/ .el-checkbox__label {
  padding: 0;
  margin: 0;
}

/* 协议区域 */
.agreement {
  display: flex;
  width: 80%;
}
.agreement >>> .el-checkbox__label {
  font-size: 0.1rem;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 0.5rem;
  font-size: 0.2rem;
  background-color: #0059ab; /* 默认禁用色 */
  border-radius: 0.1rem;
}

/* 自动登录 */
.auto-login {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btnText {
  height: 0.4rem !important;
  width: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.15rem;
  background-color: #0059ab !important;
  color: #ffffff;
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0.05rem;
  top: 0.04rem;
}
.codeFn {
  position: relative;
}
</style>